import Vue from 'vue'

Vue.filter('formatNumber', (number) => {
  if (isNaN(Number(number))) return "0.00"
  let number_format;
  return Number(number).toLocaleString(number_format, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})